import "../theme/Administracion.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { TableAdministracionPaises } from "../components/TableAdministracionPaises";
import { useDynamicAuth } from "../context/AuthProviderContext";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const AdminPagePaises = () => {
  const authProvider = useDynamicAuth();

  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color">
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a administración" />
              </div>
              <TableAdministracionPaises />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
